/** Per-tab login continuation. Never stores OAuth access or refresh tokens. */
export const MCP_CONTINUATION_KEY = 'intentico_mcp_login_transaction';
const validHandle = /^imcp_pending_[A-Za-z0-9_-]{43}$/;
export function beginMcpLogin(handle: string = 'connections'): void {
  if (handle !== 'connections' && !validHandle.test(handle)) throw new Error('Invalid connection request');
  sessionStorage.setItem(MCP_CONTINUATION_KEY, JSON.stringify({ handle, expires: Date.now() + 600_000 }));
}
export function pendingMcpLogin(): string | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(MCP_CONTINUATION_KEY) || 'null');
    if (value && (value.handle === 'connections' || validHandle.test(value.handle)) && value.expires > Date.now()) return value.handle;
  } catch { /* Discard invalid continuation. */ }
  sessionStorage.removeItem(MCP_CONTINUATION_KEY);
  return null;
}
export function consumeMcpDestination(): string | null {
  const handle = pendingMcpLogin();
  sessionStorage.removeItem(MCP_CONTINUATION_KEY);
  return handle === 'connections' ? '/settings/connected-applications' : handle ? `/mcp/authorize?request=${encodeURIComponent(handle)}` : null;
}
export function validMcpHandle(handle: string): boolean { return validHandle.test(handle); }
